(() => {
  const search = document.querySelector('[data-help-search]');
  const form = document.querySelector('[data-help-search-form]');
  const faq = document.querySelector('[data-help-faq]');
  if (!search || !form || !faq) return;
  const empty = faq.querySelector('[data-help-empty]');
  const groups = [...faq.querySelectorAll('.rdr21-help-faq__group')];
  const filter = () => {
    const query = search.value.trim().toLocaleLowerCase(document.documentElement.lang || undefined);
    let visibleCount = 0;
    groups.forEach((group) => {
      const items = [...group.querySelectorAll('[data-help-question]')];
      let groupCount = 0;
      items.forEach((item) => {
        const visible = !query || item.textContent.toLocaleLowerCase(document.documentElement.lang || undefined).includes(query);
        item.hidden = !visible;
        if (visible) { visibleCount += 1; groupCount += 1; }
      });
      group.hidden = groupCount === 0;
    });
    if (empty) empty.hidden = visibleCount > 0;
  };
  search.addEventListener('input', filter);
  form.addEventListener('submit', (event) => { event.preventDefault(); filter(); faq.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
})();
